<template>
  <div class="processHead_box">
    <el-container class="el-container-box">
      <el-header>
        <p class="coilingTitle">答题流程</p>
        <div class="tooltip_box">
          <el-tooltip placement="top">
            <div v-if="isCollection" class="elIconStar" slot="content" icon="el-icon-star-off">
              已保存到收藏夹
              <p @click="sendValueToParent">
                去查看
                <img src="../../assets/images/icon-right.png" alt="" />
              </p>
            </div>
            <div v-else slot="content" icon="el-icon-star-off" class="elIconStar">
              收藏后可查看
            </div>
            <div class="tooltipIcon" @click="collectionHandle">
              <img src="../../assets/images/icon_collection_select.png" alt="" v-if="isCollection" />
              <img v-else src="../../assets/images/icon_collection.png" alt="" />
              <span>收藏</span>
            </div>
          </el-tooltip>
          <div class="mode_select">
            <div :class="practiseMode ? 'is_select' : ''" @click="updatePractiseMode(true)">
              练习模式
            </div>
            <div :class="practiseMode ? '' : 'is_select'" @click="updatePractiseMode(false)">
              考试模式
            </div>
          </div>

          <el-button class="mode_set" plain size="small" @click="showModeDia">
            <div>
              <img class="btnIcon" src="@/assets/images/icon-setting.png" />
              <p>模式设置</p>
            </div>
          </el-button>

          <el-dropdown class="progress_create" @command="dropCommand">
            <el-button size="small" plain>
              <div class="createBtn">
                <img class="btnIcon" src="../../assets/images/icon-create.png" />
                <p>创建流程</p>
              </div>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1" style="font-size:14rem">新建流程</el-dropdown-item>
              <el-dropdown-item command="2" style="font-size:14rem">收藏流程</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
    </el-container>
    <modeDia :modeDiaVisible.sync="modeDiaVisible" ref="modeDia" />
  </div>
</template>

<script>
import { EventBus } from "@/utils/event-bus.js";
import { addStar, deleteStar, getCollectionStatus } from "@/api/addModule";
import modeDia from "./parts/modeDialog";
export default {
  props: {
    nowId: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: String
    }
  },
  components: {
    modeDia,
  },
  name: "processHead",
  computed: {
    /* coilingId(){
    console.log('计算后coilingId===', this.$store.state.coilingId);
      return this.$store.state.coilingId
    } */
  },
  watch: {
    nowId(val) {
      console.log('nowId发生变化，最新值是', val)
      this.coilingId = val;
      this.getCollectionStatus(val);
    },
    /* coilingId(val) {
    console.log('答题流程页面coilingId===', val);
    }, */
  },
  data() {
    return {
      isCollection: false,
      practiseMode: true,
      modeDiaVisible: false,
      coilingId: this.nowId,
      collectionAnswerId: 0
    };
  },
  mounted() {
      //this.getCollectionStatus()
      EventBus.$on("getProgressCollectionStatus", this.getCollectionStatus);
  },
  beforeDestroy() {
      EventBus.$off('getProgressCollectionStatus', this.getCollectionStatus)
  },
  methods: {
    //显示收藏夹
    sendValueToParent() {
      this.$emit("update:fromGrandchild", true);
    },
    collectionHandle() {
      console.log('点击收藏的时候coilingId', this.coilingId);
      //console.log('点击收藏的时候json', JSON.stringify(this.$store.state.fieldsJSON));
      /* let type = this.formData.type;
      if (type instanceof Array) {
        type = type.join("/");
      } */
      let cid = this.$store.state.coilingId
      let storageTopList = JSON.parse(sessionStorage.getItem(cid+'topList'));
      if(!storageTopList){
        storageTopList = this.$store.state.processContent
      }
      if (!this.isCollection) {
        addStar({
          coilingId: cid,
          type: this.$route.query.type,
          progress: JSON.stringify(storageTopList),
          pid: 0,
          collectionType: "answer_all",
          area: this.$route.query.region,
          year: this.$route.query.year,
          source: this.$route.query.questionSource,
        })
          .then((res) => {
            console.log(res);
            if (res["code"] == 0) {
              this.collectionAnswerId = res["data"];
              this.isCollection = true;
              this.$message.success("收藏成功！");
            } else {
              this.$message.error("收藏失败！");
            }
          })
          .catch((err) => {
            console.log("addStar err", err);
          });
      } else {
        deleteStar(this.collectionAnswerId).then((res) => {
          if (res["code"] == 0) {
            this.$message({
              message: "取消收藏成功",
              type: "success",
            });
            this.collectionAnswerId = 0;
            this.isCollection = false;
          } else {
            this.$message.error("取消收藏失败");
          }
        });
      }
      this.isCollection = !this.isCollection;
    },
    dropCommand(command) {
      if (command === "1") {
        if (this.coilingId > 0) {
          EventBus.$emit("createProgress");
          EventBus.$emit("contentChangeIdUn", this.$store.state.coilingId);
        } else {
          this.$message.error("请先新增套卷!")
        }
      } else {
          EventBus.$emit("createProgressFromCollection");
          //this.collectionProgress()
      }
      //if (command === "2") {
      //  EventBus.$emit("addFieldFromFlow");
      //}
    },

    showModeDia() {
      this.$refs.modeDia.getModeSettingData(this.pageNum)
    },

    updatePractiseMode(boolean) {
      this.practiseMode = boolean
      // 更新模式 隐藏/显示答题流程中的操作
      EventBus.$emit('updatePractiseMode', boolean)
    },
	getCollectionStatus(coid) {
        // let key = coid + "topList";
        // let progress = sessionStorage.getItem(key);
		let data = {
			collectionType: "answer_all",
			area: this.$route.query.region,
			year: this.$route.query.year,
            progress: JSON.stringify(this.$store.state.processContent),//progress,
			source: this.$route.query.questionSource,
			coilingId: coid
		};
		console.log('getCollectionStatus_data====', data);
		getCollectionStatus(data)
			.then((res) => {
				this.collectionAnswerId = res["data"];
				this.isCollection = this.collectionAnswerId > 0
				console.log('this.collectionAnswerId===', this.collectionAnswerId);
			})
			.catch((err) => {
				console.log("getList err", err);
			});
	},
    collectionProgress(){
        console.log("开始从头部开始加入流程的收藏")
        this.$emit('scjShow',{
                    n1: true,
                    n2: false,
                    nowId: 0,
                    direction: false,
                    from: "progress"
                });
    },
  },
};
</script>

<style lang="scss" scoped>
.processHead_box {
  :deep .el-icon-star-on {
    color: #fcca00;
  }

  width: 100%;
  height: 36rem;

  .el-container-box {
    height: 100%;
    box-sizing: border-box;
    // padding-top: 56rem;
    position: relative;

    .el-header {
      padding: 0;
      height: 36rem !important;
      position: absolute;
      top: 0;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .tooltip_box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      :deep .el-icon-star-on {
        color: #fcca00;
      }

      .tooltipIcon {
        cursor: pointer;
        font-size: 14rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        margin-right: 20rem;

        img {
          margin-right: 2rem;
          width: 16rem;
          height: 16rem;
        }
      }

      .mode_select {
        display: flex;
        border: 1rem solid #ffb802;
        justify-content: space-around;
        align-items: center;
        border-radius: 6rem;
        width: 170rem;
        height: 32rem;
        box-sizing: border-box;
        margin-right: 10rem;
        cursor: pointer;

        div {
          width: 83rem;
          height: 28rem;
          border-radius: 4rem;
          color: #a8abb2;
          font-size: 14rem;
          text-align: center;
          line-height: 28rem;
        }
      }

      .mode_set {
        align-items: center;
        background-image: linear-gradient(to right, #0078e7, #0295ff);
        color: #ffffff;
        border-radius: 6rem;
        font-size: 14rem;
        width: 110rem;
        height: 32rem;
        border: none;
        margin-right: 10rem;

        .btnIcon{
          height: 32rem;
        }

        div {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;

          img {
            transform: scale(0.5, 0.5);
          }
        }
      }

      .progress_create {
        width: 110rem;
        height: 32rem;
        margin-right: -10rem;
        font-size: 0;

        .createBtn{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        }
        .btnIcon{
          height: 16rem;
        }
        .el-button {
          border-radius: 6rem;
          height: 100%;
          width: 100rem;
          border: none;
          background-image: var(--background-image);
          color: #ffffff;
          font-size: 14rem;

          div {
            display: flex;
            justify-content: center;
            height: 100%;

            img {
              margin-right: 5rem;
            }
          }
        }
      }
    }
  }
}

//slot下面的样式写在最外层
.elIconStar {
  font-size: 12rem;

  p {
    color: #ffb802;
    display: inline-block;
    cursor: pointer;

    img {
      width: 6rem;
      height: 11rem;
      position: relative;
      top: 1rem;
    }
  }
}

.is_select {
  color: #ffffff !important;
  background: #ffb802;
}

.el-dropdown-menu__item {
  width: 60rem;
}

.el-dropdown-menu__item:hover {
  color: var(--primary-color);
  background-color: #d5fae0;
}
</style>